(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("BamboraWalletSDK", [], factory);
	else if(typeof exports === 'object')
		exports["BamboraWalletSDK"] = factory();
	else
		root["BamboraWalletSDK"] = factory();
})(global, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 49:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultApplePayAuthorizeProvider = void 0;
var load_script_1 = __webpack_require__(209);
var wallet_1 = __webpack_require__(548);
var ApplePay = (function (_super) {
    __extends(ApplePay, _super);
    function ApplePay(configuration, data) {
        var _this = _super.call(this, configuration, data, defaultAuthorizeProvider) || this;
        _this.init = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, load_script_1.loadScript)('https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js')];
                    case 1:
                        _a.sent();
                        this.applePaySessionData = data;
                        return [2];
                }
            });
        }); };
        _this.isAvailable = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, status;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!window.ApplePaySession || !window.ApplePaySession.supportsVersion(3)) {
                            return [2, false];
                        }
                        return [4, window.ApplePaySession.applePayCapabilities((_b = (_a = this.clientConfiguration) === null || _a === void 0 ? void 0 : _a.merchantId) !== null && _b !== void 0 ? _b : 'platformintegrator.worldline-online-checkout-prod')];
                    case 1:
                        response = _c.sent();
                        status = response.paymentCredentialStatus;
                        return [2, (status == 'paymentCredentialStatusAvailable' ||
                                status == 'paymentCredentialStatusUnknown' ||
                                status == 'paymentCredentialsUnavailable')];
                }
            });
        }); };
        _this.createButton = function (container, options) {
            var button = document.createElement('apple-pay-button');
            button.addEventListener('click', options.onClick);
            if (options.buttonStyle) {
                button.setAttribute('buttonstyle', options.buttonStyle);
            }
            if (options.buttonType) {
                button.setAttribute('type', options.buttonType);
            }
            if (options.buttonLocale) {
                button.setAttribute('locale', options.buttonLocale);
            }
            container.appendChild(button);
        };
        _this.start = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        var _a;
                        if (!window.ApplePaySession)
                            throw new Error('ApplePaySession not available');
                        var applePaySession = new window.ApplePaySession(3, __assign(__assign({}, _this.applePaySessionData), { merchantCapabilities: (_a = _this.applePaySessionData.merchantCapabilities) !== null && _a !== void 0 ? _a : ['supports3DS'] }));
                        var walletSession;
                        applePaySession.onvalidatemerchant = function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4, this.sessionProvider.fetchSession()];
                                    case 1:
                                        walletSession = _a.sent();
                                        return [3, 3];
                                    case 2:
                                        error_1 = _a.sent();
                                        applePaySession.abort();
                                        reject(error_1);
                                        return [3, 3];
                                    case 3:
                                        applePaySession.completeMerchantValidation(JSON.parse(walletSession.data.PaymentSession));
                                        return [2];
                                }
                            });
                        }); };
                        applePaySession.onpaymentauthorized = function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var authorizePaymentResponse, authorizeResult;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4, this.authorizeProvider.authorizePayment(walletSession, event.payment)];
                                    case 1:
                                        authorizePaymentResponse = _b.sent();
                                        authorizeResult = ((_a = authorizePaymentResponse.authorizeResult) !== null && _a !== void 0 ? _a : authorizePaymentResponse.wait)
                                            ? window.ApplePaySession.STATUS_SUCCESS
                                            : window.ApplePaySession.STATUS_FAILURE;
                                        applePaySession.completePayment(authorizeResult);
                                        resolve(authorizePaymentResponse);
                                        return [2];
                                }
                            });
                        }); };
                        applePaySession.oncancel = function (event) { return reject(event); };
                        applePaySession.begin();
                    })];
            });
        }); };
        _this.clientConfiguration = configuration.clientConfiguration;
        return _this;
    }
    ApplePay.create = function (configuration, data) {
        return __awaiter(this, void 0, void 0, function () {
            var applePay;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        applePay = new ApplePay(configuration, data);
                        return [4, applePay.init(data)];
                    case 1:
                        _a.sent();
                        return [2, applePay];
                }
            });
        });
    };
    return ApplePay;
}(wallet_1.WalletDirectBase));
exports["default"] = ApplePay;
var DefaultApplePayAuthorizeProvider = (function () {
    function DefaultApplePayAuthorizeProvider() {
    }
    DefaultApplePayAuthorizeProvider.prototype.authorizePayment = function (walletSession, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch(walletSession.data.CallbackUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                                Authorization: walletSession.data.Identifier,
                            },
                            body: JSON.stringify(data),
                        })];
                    case 1:
                        response = _a.sent();
                        return [4, response.json()];
                    case 2: return [2, (_a.sent())];
                }
            });
        });
    };
    return DefaultApplePayAuthorizeProvider;
}());
exports.DefaultApplePayAuthorizeProvider = DefaultApplePayAuthorizeProvider;
var defaultAuthorizeProvider = new DefaultApplePayAuthorizeProvider();
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 453:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultGooglePayAuthorizeProvider = void 0;
var load_script_1 = __webpack_require__(209);
var wallet_1 = __webpack_require__(548);
var GooglePay = (function (_super) {
    __extends(GooglePay, _super);
    function GooglePay(configuration, data) {
        var _this = _super.call(this, configuration, data, defaultAuthorizeProvider) || this;
        _this.isReady = function () { return __awaiter(_this, void 0, void 0, function () {
            var isReadyToPayResponse;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4, this.client.isReadyToPay({
                            allowedPaymentMethods: this.mapAllowedPaymentMethods(this.data.allowedPaymentMethods),
                            apiVersion: (_a = this.data.apiVersion) !== null && _a !== void 0 ? _a : 2,
                            apiVersionMinor: (_c = (_b = this.data) === null || _b === void 0 ? void 0 : _b.apiVersionMinor) !== null && _c !== void 0 ? _c : 0,
                        })];
                    case 1:
                        isReadyToPayResponse = _d.sent();
                        return [2, isReadyToPayResponse.result];
                }
            });
        }); };
        _this.createButton = function (container, options) {
            var button = _this.client.createButton(options);
            container.appendChild(button);
        };
        _this.start = function () { return __awaiter(_this, void 0, void 0, function () {
            var paymentData, walletSession, authorizePaymentResponse;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4, this.client.loadPaymentData(__assign(__assign({}, this.data), { apiVersion: (_a = this.data.apiVersion) !== null && _a !== void 0 ? _a : 2, apiVersionMinor: (_b = this.data.apiVersionMinor) !== null && _b !== void 0 ? _b : 0, allowedPaymentMethods: this.mapAllowedPaymentMethods(this.data.allowedPaymentMethods), transactionInfo: __assign(__assign({}, this.data.transactionInfo), { totalPriceStatus: (_c = this.data.transactionInfo.totalPriceStatus) !== null && _c !== void 0 ? _c : 'FINAL' }) }))];
                    case 1:
                        paymentData = _d.sent();
                        return [4, this.sessionProvider.fetchSession()];
                    case 2:
                        walletSession = _d.sent();
                        return [4, this.authorizeProvider.authorizePayment(walletSession, paymentData)];
                    case 3:
                        authorizePaymentResponse = _d.sent();
                        if (authorizePaymentResponse.stepUp) {
                            this.authorizeProvider.stepUp(authorizePaymentResponse);
                            return [2];
                        }
                        return [2, authorizePaymentResponse];
                }
            });
        }); };
        _this.init = function (environment) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!('google' in (window || global) && !!((_b = (_a = google === null || google === void 0 ? void 0 : google.payments) === null || _a === void 0 ? void 0 : _a.api) === null || _b === void 0 ? void 0 : _b.PaymentsClient))) return [3, 2];
                        return [4, (0, load_script_1.loadScript)('https://pay.google.com/gp/p/js/pay.js')];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        this.client = new window.google.payments.api.PaymentsClient({
                            environment: environment !== null && environment !== void 0 ? environment : 'PRODUCTION',
                        });
                        return [2];
                }
            });
        }); };
        _this.mapAllowedPaymentMethods = function (allowedPaymentMethods) {
            return allowedPaymentMethods.map(function (paymentMethod) {
                return {
                    type: 'CARD',
                    parameters: __assign(__assign({}, paymentMethod.parameters), { allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'] }),
                    tokenizationSpecification: {
                        type: 'PAYMENT_GATEWAY',
                        parameters: {
                            gateway: 'worldlineonlinecheckout',
                            gatewayMerchantId: paymentMethod.tokenizationSpecification.parameters.gatewayMerchantId,
                        },
                    },
                };
            });
        };
        return _this;
    }
    GooglePay.create = function (configuration, data) {
        return __awaiter(this, void 0, void 0, function () {
            var googlePay;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        googlePay = new GooglePay(configuration, data);
                        return [4, googlePay.init(configuration.clientConfiguration && configuration.clientConfiguration.environment)];
                    case 1:
                        _a.sent();
                        return [2, googlePay];
                }
            });
        });
    };
    return GooglePay;
}(wallet_1.WalletDirectBase));
exports["default"] = GooglePay;
var DefaultGooglePayAuthorizeProvider = (function () {
    function DefaultGooglePayAuthorizeProvider() {
    }
    DefaultGooglePayAuthorizeProvider.prototype.authorizePayment = function (walletSession, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch(walletSession.data.CallbackUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                                Authorization: walletSession.data.Identifier,
                            },
                            body: data.paymentMethodData.tokenizationData.token,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4, response.json()];
                    case 2: return [2, (_a.sent())];
                }
            });
        });
    };
    DefaultGooglePayAuthorizeProvider.prototype.stepUp = function (authorizeResult) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var response, data, formElement_1;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4, fetch(authorizeResult.redirectUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                            },
                            body: JSON.stringify({
                                browserinformation: {
                                    javaenabled: false,
                                    javascriptenabled: true,
                                    language: (_a = navigator === null || navigator === void 0 ? void 0 : navigator.language) !== null && _a !== void 0 ? _a : 'en-US',
                                    colordepth: (_b = screen === null || screen === void 0 ? void 0 : screen.colorDepth) !== null && _b !== void 0 ? _b : 24,
                                    screenheight: (_c = screen === null || screen === void 0 ? void 0 : screen.availHeight) !== null && _c !== void 0 ? _c : 600,
                                    screenwidth: (_d = screen === null || screen === void 0 ? void 0 : screen.availWidth) !== null && _d !== void 0 ? _d : 800,
                                    timezoneoffset: new Date().getTimezoneOffset(),
                                },
                            }),
                        })];
                    case 1:
                        response = _f.sent();
                        return [4, response.json()];
                    case 2:
                        data = _f.sent();
                        if ((_e = data === null || data === void 0 ? void 0 : data.meta) === null || _e === void 0 ? void 0 : _e.result) {
                            formElement_1 = document.createElement('form');
                            formElement_1.target = '_top';
                            formElement_1.method = 'POST';
                            formElement_1.action = data.redirecturl;
                            formElement_1.style.display = 'none';
                            data.parameters.forEach(function (x) {
                                var inputElement = document.createElement('input');
                                inputElement.name = x.name;
                                inputElement.value = x.value;
                                inputElement.type = 'hidden';
                                formElement_1.appendChild(inputElement);
                            });
                            document.body.appendChild(formElement_1);
                            formElement_1.submit();
                        }
                        else {
                            window.location.href = data.redirecturl;
                        }
                        return [2];
                }
            });
        });
    };
    return DefaultGooglePayAuthorizeProvider;
}());
exports.DefaultGooglePayAuthorizeProvider = DefaultGooglePayAuthorizeProvider;
var defaultAuthorizeProvider = new DefaultGooglePayAuthorizeProvider();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ29vZ2xlcGF5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NsaWVudHMvZ29vZ2xlcGF5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsb0RBQWlEO0FBQ2pELG9DQVNrQjtBQUVsQjtJQUNVLDZCQU9QO0lBS0QsbUJBQ0UsYUFNQyxFQUNELElBQW9CO1FBUnRCLFlBVUUsa0JBQU0sYUFBYSxFQUFFLElBQUksRUFBRSx3QkFBd0IsQ0FBQyxTQUNyRDtRQW1CTSxhQUFPLEdBQUc7Ozs7OzRCQUNjLFdBQU0sSUFBSSxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUM7NEJBQzFELHFCQUFxQixFQUFFLElBQUksQ0FBQyx3QkFBd0IsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLHFCQUFxQixDQUFDOzRCQUNyRixVQUFVLEVBQUUsTUFBQSxJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsbUNBQUksQ0FBQzs0QkFDckMsZUFBZSxFQUFFLE1BQUEsTUFBQSxJQUFJLENBQUMsSUFBSSwwQ0FBRSxlQUFlLG1DQUFJLENBQUM7eUJBQ2pELENBQUMsRUFBQTs7d0JBSkksb0JBQW9CLEdBQUcsU0FJM0I7d0JBRUYsV0FBTyxvQkFBb0IsQ0FBQyxNQUFNLEVBQUE7OzthQUNuQyxDQUFBO1FBRU0sa0JBQVksR0FBRyxVQUFDLFNBQXNCLEVBQUUsT0FBMEM7WUFDdkYsSUFBTSxNQUFNLEdBQUcsS0FBSSxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLENBQUE7WUFDaEQsU0FBUyxDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUMsQ0FBQTtRQUMvQixDQUFDLENBQUE7UUFFZSxXQUFLLEdBQUc7Ozs7OzRCQUNGLFdBQU0sSUFBSSxDQUFDLE1BQU0sQ0FBQyxlQUFlLHVCQUNoRCxJQUFJLENBQUMsSUFBSSxLQUNaLFVBQVUsRUFBRSxNQUFBLElBQUksQ0FBQyxJQUFJLENBQUMsVUFBVSxtQ0FBSSxDQUFDLEVBQ3JDLGVBQWUsRUFBRSxNQUFBLElBQUksQ0FBQyxJQUFJLENBQUMsZUFBZSxtQ0FBSSxDQUFDLEVBQy9DLHFCQUFxQixFQUFFLElBQUksQ0FBQyx3QkFBd0IsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLHFCQUFxQixDQUFDLEVBQ3JGLGVBQWUsd0JBQ1YsSUFBSSxDQUFDLElBQUksQ0FBQyxlQUFlLEtBQzVCLGdCQUFnQixFQUFFLE1BQUEsSUFBSSxDQUFDLElBQUksQ0FBQyxlQUFlLENBQUMsZ0JBQWdCLG1DQUFJLE9BQU8sT0FFekUsRUFBQTs7d0JBVEksV0FBVyxHQUFHLFNBU2xCO3dCQUVvQixXQUFNLElBQUksQ0FBQyxlQUFlLENBQUMsWUFBWSxFQUFFLEVBQUE7O3dCQUF6RCxhQUFhLEdBQUcsU0FBeUM7d0JBRTlCLFdBQU0sSUFBSSxDQUFDLGlCQUFpQixDQUFDLGdCQUFnQixDQUFDLGFBQWEsRUFBRSxXQUFXLENBQUMsRUFBQTs7d0JBQXBHLHdCQUF3QixHQUFHLFNBQXlFO3dCQUUxRyxJQUFJLHdCQUF3QixDQUFDLE1BQU0sRUFBRTs0QkFDbkMsSUFBSSxDQUFDLGlCQUFpQixDQUFDLE1BQU0sQ0FBQyx3QkFBd0IsQ0FBQyxDQUFBOzRCQUN2RCxXQUFNO3lCQUNQO3dCQUVELFdBQU8sd0JBQXdCLEVBQUE7OzthQUNoQyxDQUFBO1FBRU8sVUFBSSxHQUFHLFVBQU8sV0FBK0Q7Ozs7OzZCQUMvRSxDQUFDLENBQUMsUUFBUSxJQUFJLENBQUMsTUFBTSxJQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFBLE1BQUEsTUFBQSxNQUFNLGFBQU4sTUFBTSx1QkFBTixNQUFNLENBQUUsUUFBUSwwQ0FBRSxHQUFHLDBDQUFFLGNBQWMsQ0FBQSxDQUFDLEVBQTVFLGNBQTRFO3dCQUM5RSxXQUFNLElBQUEsd0JBQVUsRUFBQyx1Q0FBdUMsQ0FBQyxFQUFBOzt3QkFBekQsU0FBeUQsQ0FBQTs7O3dCQUczRCxJQUFJLENBQUMsTUFBTSxHQUFHLElBQUksTUFBTSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLGNBQWMsQ0FBQzs0QkFDMUQsV0FBVyxFQUFFLFdBQVcsYUFBWCxXQUFXLGNBQVgsV0FBVyxHQUFJLFlBQVk7eUJBQ3pDLENBQUMsQ0FBQTs7OzthQUNILENBQUE7UUFFTyw4QkFBd0IsR0FBRyxVQUNqQyxxQkFBa0U7WUFFbEUsT0FBTyxxQkFBcUIsQ0FBQyxHQUFHLENBQUMsVUFBQyxhQUFhO2dCQUM3QyxPQUFPO29CQUNMLElBQUksRUFBRSxNQUFNO29CQUNaLFVBQVUsd0JBQ0wsYUFBYSxDQUFDLFVBQVUsS0FDM0Isa0JBQWtCLEVBQUUsQ0FBQyxVQUFVLEVBQUUsZ0JBQWdCLENBQUMsR0FDbkQ7b0JBQ0QseUJBQXlCLEVBQUU7d0JBQ3pCLElBQUksRUFBRSxpQkFBaUI7d0JBQ3ZCLFVBQVUsRUFBRTs0QkFDVixPQUFPLEVBQUUseUJBQXlCOzRCQUNsQyxpQkFBaUIsRUFBRSxhQUFhLENBQUMseUJBQXlCLENBQUMsVUFBVSxDQUFDLGlCQUFpQjt5QkFDeEY7cUJBQ0Y7aUJBQ2dELENBQUE7WUFDckQsQ0FBQyxDQUFDLENBQUE7UUFDSixDQUFDLENBQUE7O0lBdkZELENBQUM7SUFFbUIsZ0JBQU0sR0FBMUIsVUFDRSxhQU1DLEVBQ0QsSUFBb0I7Ozs7Ozt3QkFFZCxTQUFTLEdBQUcsSUFBSSxTQUFTLENBQUMsYUFBYSxFQUFFLElBQUksQ0FBQyxDQUFBO3dCQUVwRCxXQUFNLFNBQVMsQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLG1CQUFtQixJQUFJLGFBQWEsQ0FBQyxtQkFBbUIsQ0FBQyxXQUFXLENBQUMsRUFBQTs7d0JBQXhHLFNBQXdHLENBQUE7d0JBRXhHLFdBQU8sU0FBUyxFQUFBOzs7O0tBQ2pCO0lBdUVILGdCQUFDO0FBQUQsQ0FBQyxBQWhIRCxDQUNVLHlCQUFnQixHQStHekI7O0FBT0Q7SUFBQTtJQThEQSxDQUFDO0lBN0RPLDREQUFnQixHQUF0QixVQUNFLGFBQTZDLEVBQzdDLElBQXFDOzs7Ozs0QkFFcEIsV0FBTSxLQUFLLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxXQUFXLEVBQUU7NEJBQzNELE1BQU0sRUFBRSxNQUFNOzRCQUNkLE9BQU8sRUFBRTtnQ0FDUCxjQUFjLEVBQUUsa0JBQWtCO2dDQUNsQyxNQUFNLEVBQUUsa0JBQWtCO2dDQUMxQixhQUFhLEVBQUUsYUFBYSxDQUFDLElBQUksQ0FBQyxVQUFVOzZCQUM3Qzs0QkFDRCxJQUFJLEVBQUUsSUFBSSxDQUFDLGlCQUFpQixDQUFDLGdCQUFnQixDQUFDLEtBQUs7eUJBQ3BELENBQUMsRUFBQTs7d0JBUkksUUFBUSxHQUFHLFNBUWY7d0JBRU0sV0FBTSxRQUFRLENBQUMsSUFBSSxFQUFFLEVBQUE7NEJBQTdCLFdBQU8sQ0FBQyxTQUFxQixDQUErQixFQUFBOzs7O0tBQzdEO0lBRUssa0RBQU0sR0FBWixVQUFhLGVBQTJDOzs7Ozs7NEJBQ3JDLFdBQU0sS0FBSyxDQUFDLGVBQWUsQ0FBQyxXQUFXLEVBQUU7NEJBQ3hELE1BQU0sRUFBRSxNQUFNOzRCQUNkLE9BQU8sRUFBRTtnQ0FDUCxjQUFjLEVBQUUsa0JBQWtCO2dDQUNsQyxNQUFNLEVBQUUsa0JBQWtCOzZCQUMzQjs0QkFDRCxJQUFJLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQztnQ0FDbkIsa0JBQWtCLEVBQUU7b0NBQ2xCLFdBQVcsRUFBRSxLQUFLO29DQUNsQixpQkFBaUIsRUFBRSxJQUFJO29DQUN2QixRQUFRLEVBQUUsTUFBQSxTQUFTLGFBQVQsU0FBUyx1QkFBVCxTQUFTLENBQUUsUUFBUSxtQ0FBSSxPQUFPO29DQUN4QyxVQUFVLEVBQUUsTUFBQSxNQUFNLGFBQU4sTUFBTSx1QkFBTixNQUFNLENBQUUsVUFBVSxtQ0FBSSxFQUFFO29DQUNwQyxZQUFZLEVBQUUsTUFBQSxNQUFNLGFBQU4sTUFBTSx1QkFBTixNQUFNLENBQUUsV0FBVyxtQ0FBSSxHQUFHO29DQUN4QyxXQUFXLEVBQUUsTUFBQSxNQUFNLGFBQU4sTUFBTSx1QkFBTixNQUFNLENBQUUsVUFBVSxtQ0FBSSxHQUFHO29DQUN0QyxjQUFjLEVBQUUsSUFBSSxJQUFJLEVBQUUsQ0FBQyxpQkFBaUIsRUFBRTtpQ0FDL0M7NkJBQ0YsQ0FBQzt5QkFDSCxDQUFDLEVBQUE7O3dCQWpCSSxRQUFRLEdBQUcsU0FpQmY7d0JBRVcsV0FBTSxRQUFRLENBQUMsSUFBSSxFQUFFLEVBQUE7O3dCQUE1QixJQUFJLEdBQUcsU0FBcUI7d0JBRWxDLElBQUksTUFBQSxJQUFJLGFBQUosSUFBSSx1QkFBSixJQUFJLENBQUUsSUFBSSwwQ0FBRSxNQUFNLEVBQUU7NEJBQ2hCLGdCQUFjLFFBQVEsQ0FBQyxhQUFhLENBQUMsTUFBTSxDQUFDLENBQUE7NEJBQ2xELGFBQVcsQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFBOzRCQUMzQixhQUFXLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQTs0QkFDM0IsYUFBVyxDQUFDLE1BQU0sR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFBOzRCQUNyQyxhQUFXLENBQUMsS0FBSyxDQUFDLE9BQU8sR0FBRyxNQUFNLENBQUE7NEJBRWxDLElBQUksQ0FBQyxVQUFVLENBQUMsT0FBTyxDQUFDLFVBQUMsQ0FBQztnQ0FDeEIsSUFBTSxZQUFZLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxPQUFPLENBQUMsQ0FBQTtnQ0FDcEQsWUFBWSxDQUFDLElBQUksR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFBO2dDQUMxQixZQUFZLENBQUMsS0FBSyxHQUFHLENBQUMsQ0FBQyxLQUFLLENBQUE7Z0NBQzVCLFlBQVksQ0FBQyxJQUFJLEdBQUcsUUFBUSxDQUFBO2dDQUU1QixhQUFXLENBQUMsV0FBVyxDQUFDLFlBQVksQ0FBQyxDQUFBOzRCQUN2QyxDQUFDLENBQUMsQ0FBQTs0QkFFRixRQUFRLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxhQUFXLENBQUMsQ0FBQTs0QkFDdEMsYUFBVyxDQUFDLE1BQU0sRUFBRSxDQUFBO3lCQUNyQjs2QkFBTTs0QkFDTCxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFBO3lCQUN4Qzs7Ozs7S0FDRjtJQUNILHdDQUFDO0FBQUQsQ0FBQyxBQTlERCxJQThEQztBQTlEWSw4RUFBaUM7QUFnRTlDLElBQU0sd0JBQXdCLEdBQXNDLElBQUksaUNBQWlDLEVBQUUsQ0FBQSJ9

/***/ }),

/***/ 260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(41), exports);
__exportStar(__webpack_require__(898), exports);
__exportStar(__webpack_require__(453), exports);
__exportStar(__webpack_require__(49), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY2xpZW50cy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsOENBQTJCO0FBQzNCLDBDQUF1QjtBQUN2Qiw4Q0FBMkI7QUFDM0IsNkNBQTBCIn0=

/***/ }),

/***/ 41:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var wallet_1 = __webpack_require__(548);
var MobilePay = (function (_super) {
    __extends(MobilePay, _super);
    function MobilePay(configuration, data) {
        var _this = this;
        var _a;
        _this = _super.call(this, configuration, data) || this;
        _this._target = '_top';
        _this.start = function () { return __awaiter(_this, void 0, void 0, function () {
            var walletSession, target;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.sessionProvider.fetchSession()];
                    case 1:
                        walletSession = _b.sent();
                        if (this._target === '_top') {
                            target = (_a = window.top) !== null && _a !== void 0 ? _a : window;
                            target.location.href = walletSession.data.Url;
                        }
                        else {
                            window.location.href = walletSession.data.Url;
                        }
                        return [2];
                }
            });
        }); };
        _this._target = (_a = data === null || data === void 0 ? void 0 : data.target) !== null && _a !== void 0 ? _a : _this._target;
        return _this;
    }
    MobilePay.create = function (configuration, data) {
        return new MobilePay(configuration, data);
    };
    return MobilePay;
}(wallet_1.WalletOffsiteBase));
exports["default"] = MobilePay;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9iaWxlcGF5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NsaWVudHMvbW9iaWxlcGF5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsb0NBQThHO0FBRTlHO0lBQXVDLDZCQUE4RTtJQUduSCxtQkFDRSxhQUFpRixFQUNqRixJQUFxQjtRQUZ2QixpQkFPQzs7Z0JBSEMsa0JBQU0sYUFBYSxFQUFFLElBQUksQ0FBQztRQU5wQixhQUFPLEdBQUcsTUFBTSxDQUFBO1FBa0JSLFdBQUssR0FBRzs7Ozs7NEJBQ0EsV0FBTSxJQUFJLENBQUMsZUFBZSxDQUFDLFlBQVksRUFBRSxFQUFBOzt3QkFBekQsYUFBYSxHQUFHLFNBQXlDO3dCQUUvRCxJQUFJLElBQUksQ0FBQyxPQUFPLEtBQUssTUFBTSxFQUFFOzRCQUNyQixNQUFNLEdBQUcsTUFBQSxNQUFNLENBQUMsR0FBRyxtQ0FBSSxNQUFNLENBQUE7NEJBQ25DLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBSSxHQUFHLGFBQWEsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFBO3lCQUM5Qzs2QkFBTTs0QkFDTCxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksR0FBRyxhQUFhLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQTt5QkFDOUM7Ozs7YUFDRixDQUFBO1FBbkJDLEtBQUksQ0FBQyxPQUFPLEdBQUcsTUFBQSxJQUFJLGFBQUosSUFBSSx1QkFBSixJQUFJLENBQUUsTUFBTSxtQ0FBSSxLQUFJLENBQUMsT0FBTyxDQUFBOztJQUM3QyxDQUFDO0lBRWEsZ0JBQU0sR0FBcEIsVUFDRSxhQUFpRixFQUNqRixJQUFxQjtRQUVyQixPQUFPLElBQUksU0FBUyxDQUFDLGFBQWEsRUFBRSxJQUFJLENBQUMsQ0FBQTtJQUMzQyxDQUFDO0lBWUgsZ0JBQUM7QUFBRCxDQUFDLEFBN0JELENBQXVDLDBCQUFpQixHQTZCdkQifQ==

/***/ }),

/***/ 898:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var wallet_1 = __webpack_require__(548);
var Vipps = (function (_super) {
    __extends(Vipps, _super);
    function Vipps(configuration, data) {
        var _this = this;
        var _a;
        _this = _super.call(this, configuration, data) || this;
        _this._target = '_top';
        _this.start = function () { return __awaiter(_this, void 0, void 0, function () {
            var walletSession, target;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.sessionProvider.fetchSession()];
                    case 1:
                        walletSession = _b.sent();
                        if (this._target === '_top') {
                            target = (_a = window.top) !== null && _a !== void 0 ? _a : window;
                            target.location.href = walletSession.data.url;
                        }
                        else {
                            window.location.href = walletSession.data.url;
                        }
                        return [2];
                }
            });
        }); };
        _this._target = (_a = data === null || data === void 0 ? void 0 : data.target) !== null && _a !== void 0 ? _a : _this._target;
        return _this;
    }
    Vipps.create = function (configuration, data) {
        return new Vipps(configuration, data);
    };
    return Vipps;
}(wallet_1.WalletOffsiteBase));
exports["default"] = Vipps;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlwcHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY2xpZW50cy92aXBwcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLG9DQUE4RztBQUU5RztJQUFtQyx5QkFBc0U7SUFHdkcsZUFDRSxhQUE2RSxFQUM3RSxJQUFpQjtRQUZuQixpQkFPQzs7Z0JBSEMsa0JBQU0sYUFBYSxFQUFFLElBQUksQ0FBQztRQU5wQixhQUFPLEdBQUcsTUFBTSxDQUFBO1FBa0JSLFdBQUssR0FBRzs7Ozs7NEJBQ0EsV0FBTSxJQUFJLENBQUMsZUFBZSxDQUFDLFlBQVksRUFBRSxFQUFBOzt3QkFBekQsYUFBYSxHQUFHLFNBQXlDO3dCQUUvRCxJQUFJLElBQUksQ0FBQyxPQUFPLEtBQUssTUFBTSxFQUFFOzRCQUNyQixNQUFNLEdBQUcsTUFBQSxNQUFNLENBQUMsR0FBRyxtQ0FBSSxNQUFNLENBQUE7NEJBQ25DLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBSSxHQUFHLGFBQWEsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFBO3lCQUM5Qzs2QkFBTTs0QkFDTCxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksR0FBRyxhQUFhLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQTt5QkFDOUM7Ozs7YUFDRixDQUFBO1FBbkJDLEtBQUksQ0FBQyxPQUFPLEdBQUcsTUFBQSxJQUFJLGFBQUosSUFBSSx1QkFBSixJQUFJLENBQUUsTUFBTSxtQ0FBSSxLQUFJLENBQUMsT0FBTyxDQUFBOztJQUM3QyxDQUFDO0lBRWEsWUFBTSxHQUFwQixVQUNFLGFBQTZFLEVBQzdFLElBQWlCO1FBRWpCLE9BQU8sSUFBSSxLQUFLLENBQUMsYUFBYSxFQUFFLElBQUksQ0FBQyxDQUFBO0lBQ3ZDLENBQUM7SUFZSCxZQUFDO0FBQUQsQ0FBQyxBQTdCRCxDQUFtQywwQkFBaUIsR0E2Qm5EIn0=

/***/ }),

/***/ 607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Vipps = exports.MobilePay = exports.GooglePay = exports.ApplePay = void 0;
var applepay_1 = __webpack_require__(49);
exports.ApplePay = applepay_1.default;
var googlepay_1 = __webpack_require__(453);
exports.GooglePay = googlepay_1.default;
var mobilepay_1 = __webpack_require__(41);
exports.MobilePay = mobilepay_1.default;
var vipps_1 = __webpack_require__(898);
exports.Vipps = vipps_1.default;
__exportStar(__webpack_require__(260), exports);
__exportStar(__webpack_require__(548), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwrQ0FBeUM7QUFLaEMsbUJBTEYsa0JBQVEsQ0FLRTtBQUpqQixpREFBMkM7QUFJeEIsb0JBSlosbUJBQVMsQ0FJWTtBQUg1QixpREFBMkM7QUFHYixvQkFIdkIsbUJBQVMsQ0FHdUI7QUFGdkMseUNBQW1DO0FBRU0sZ0JBRmxDLGVBQUssQ0FFa0M7QUFDOUMsa0RBQStCO0FBQy9CLDJDQUF3QiJ9

/***/ }),

/***/ 209:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.clearScriptCache = exports.loadScript = void 0;
var cachedScripts = {};
function loadScript(src) {
    var existing = cachedScripts[src];
    if (existing) {
        return existing;
    }
    var promise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        var onScriptLoad = function () {
            resolve();
        };
        var onScriptError = function () {
            cleanup();
            delete cachedScripts[src];
            script.remove();
            reject(new Error("Unable to load script ".concat(src)));
        };
        script.addEventListener('load', onScriptLoad);
        script.addEventListener('error', onScriptError);
        document.body.appendChild(script);
        function cleanup() {
            script.removeEventListener('load', onScriptLoad);
            script.removeEventListener('error', onScriptError);
        }
    });
    cachedScripts[src] = promise;
    return promise;
}
exports.loadScript = loadScript;
function clearScriptCache() {
    cachedScripts = {};
}
exports.clearScriptCache = clearScriptCache;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9hZC1zY3JpcHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvbG9hZC1zY3JpcHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBSSxhQUFhLEdBQWtDLEVBQUUsQ0FBQTtBQUVyRCxTQUFnQixVQUFVLENBQUMsR0FBVztJQUNwQyxJQUFNLFFBQVEsR0FBRyxhQUFhLENBQUMsR0FBRyxDQUFDLENBQUE7SUFDbkMsSUFBSSxRQUFRLEVBQUU7UUFDWixPQUFPLFFBQVEsQ0FBQTtLQUNoQjtJQUVELElBQU0sT0FBTyxHQUFHLElBQUksT0FBTyxDQUFPLFVBQUMsT0FBTyxFQUFFLE1BQU07UUFFaEQsSUFBTSxNQUFNLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQTtRQUMvQyxNQUFNLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQTtRQUNoQixNQUFNLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQTtRQUduQixJQUFNLFlBQVksR0FBRztZQUNuQixPQUFPLEVBQUUsQ0FBQTtRQUNYLENBQUMsQ0FBQTtRQUVELElBQU0sYUFBYSxHQUFHO1lBRXBCLE9BQU8sRUFBRSxDQUFBO1lBR1QsT0FBTyxhQUFhLENBQUMsR0FBRyxDQUFDLENBQUE7WUFDekIsTUFBTSxDQUFDLE1BQU0sRUFBRSxDQUFBO1lBRWYsTUFBTSxDQUFDLElBQUksS0FBSyxDQUFDLGdDQUF5QixHQUFHLENBQUUsQ0FBQyxDQUFDLENBQUE7UUFDbkQsQ0FBQyxDQUFBO1FBRUQsTUFBTSxDQUFDLGdCQUFnQixDQUFDLE1BQU0sRUFBRSxZQUFZLENBQUMsQ0FBQTtRQUM3QyxNQUFNLENBQUMsZ0JBQWdCLENBQUMsT0FBTyxFQUFFLGFBQWEsQ0FBQyxDQUFBO1FBRy9DLFFBQVEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBR2pDLFNBQVMsT0FBTztZQUNkLE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxNQUFNLEVBQUUsWUFBWSxDQUFDLENBQUE7WUFDaEQsTUFBTSxDQUFDLG1CQUFtQixDQUFDLE9BQU8sRUFBRSxhQUFhLENBQUMsQ0FBQTtRQUNwRCxDQUFDO0lBQ0gsQ0FBQyxDQUFDLENBQUE7SUFFRixhQUFhLENBQUMsR0FBRyxDQUFDLEdBQUcsT0FBTyxDQUFBO0lBRTVCLE9BQU8sT0FBTyxDQUFBO0FBQ2hCLENBQUM7QUE1Q0QsZ0NBNENDO0FBRUQsU0FBZ0IsZ0JBQWdCO0lBQzlCLGFBQWEsR0FBRyxFQUFFLENBQUE7QUFDcEIsQ0FBQztBQUZELDRDQUVDIn0=

/***/ }),

/***/ 548:
/***/ (function(__unused_webpack_module, exports) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WalletDirectBase = exports.WalletOffsiteBase = void 0;
var WalletBase = (function () {
    function WalletBase(configuration, data) {
        this.data = data;
        if (!configuration) {
            throw new Error('Configuration must be provided');
        }
        if (!configuration.sessionProvider) {
            throw new Error('Configuration sessionProvider must be implemented');
        }
        this.sessionProvider = configuration.sessionProvider;
    }
    return WalletBase;
}());
var WalletOffsiteBase = (function (_super) {
    __extends(WalletOffsiteBase, _super);
    function WalletOffsiteBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WalletOffsiteBase;
}(WalletBase));
exports.WalletOffsiteBase = WalletOffsiteBase;
var WalletDirectBase = (function (_super) {
    __extends(WalletDirectBase, _super);
    function WalletDirectBase(configuration, data, defaultAuthorizeProvider) {
        var _this = this;
        var _a;
        _this = _super.call(this, configuration, data) || this;
        _this.authorizeProvider = (_a = configuration.authorizeProvider) !== null && _a !== void 0 ? _a : defaultAuthorizeProvider;
        return _this;
    }
    return WalletDirectBase;
}(WalletBase));
exports.WalletDirectBase = WalletDirectBase;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2FsbGV0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3dhbGxldC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFnQ0E7SUFTRSxvQkFBWSxhQUFpRSxFQUFFLElBQVk7UUFDekYsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUE7UUFFaEIsSUFBSSxDQUFDLGFBQWEsRUFBRTtZQUNsQixNQUFNLElBQUksS0FBSyxDQUFDLGdDQUFnQyxDQUFDLENBQUE7U0FDbEQ7UUFFRCxJQUFJLENBQUMsYUFBYSxDQUFDLGVBQWUsRUFBRTtZQUNsQyxNQUFNLElBQUksS0FBSyxDQUFDLG1EQUFtRCxDQUFDLENBQUE7U0FDckU7UUFFRCxJQUFJLENBQUMsZUFBZSxHQUFHLGFBQWEsQ0FBQyxlQUFlLENBQUE7SUFDdEQsQ0FBQztJQUNILGlCQUFDO0FBQUQsQ0FBQyxBQXRCRCxJQXNCQztBQUVEO0lBS1UscUNBQXFEO0lBTC9EOztJQVNBLENBQUM7SUFBRCx3QkFBQztBQUFELENBQUMsQUFURCxDQUtVLFVBQVUsR0FJbkI7QUFUcUIsOENBQWlCO0FBV3ZDO0lBUVUsb0NBQXFEO0lBTTdELDBCQUNFLGFBTUMsRUFDRCxJQUFXLEVBQ1gsd0JBQTRDO1FBVDlDLGlCQWNDOztnQkFIQyxrQkFBTSxhQUFhLEVBQUUsSUFBSSxDQUFDO1FBRTFCLEtBQUksQ0FBQyxpQkFBaUIsR0FBRyxNQUFBLGFBQWEsQ0FBQyxpQkFBaUIsbUNBQUksd0JBQXdCLENBQUE7O0lBQ3RGLENBQUM7SUFHSCx1QkFBQztBQUFELENBQUMsQUEvQkQsQ0FRVSxVQUFVLEdBdUJuQjtBQS9CcUIsNENBQWdCIn0=

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(607);
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});